<template>

  <div class="sub-page-layout">
    <div class="inner">

      <div class="ad_wrap mid" v-if="showTopBanner && !isCurrentGNB('poll')">
        <display-container :section="311" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="7094374816"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

      </div>

      <!-- 컨텐츠 -->
      <article class="articles" :class="{ margin_top: showTopBanner, no_border: noBorder }">

        <div class="left">
          <slot />
        </div>

        <div class="right" :class="{ no_padding_top: noRightPaddingTop}">
          <div class="ad" ref="adArea">
            <display-container :section="312" align="right" empty-bg-color="transparent">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
              </template>
            </display-container>
          </div>
          <div class="tnmt_sche" :class="{ 'no-ad': !hasAdElement }">
            <div class="title">
							<p class="subj"><i>Upcoming Tournaments</i></p>
							<router-link to="/tournaments" class="more">more</router-link>
						</div>
            <template v-for="tnmt in getUpcomingTournaments">
              <router-link :to="`/tournament/${tnmt.idx}`" class="ctnr" :key="tnmt.idx">
                <div class="brand">
                  <p class="img"><img v-if="isFileExist(tnmt.brand_logo_img)" :src="tnmt.brand_logo_img.url"></p>
                </div>
                <div class="cont">
                  <h5 v-html="tnmt.title"></h5>
                  <h6>{{tnmt.venue}}, {{tnmt.country_name}}</h6>
                </div>
                <div class="date"><b>{{tnmt.start_date}}</b> ~ {{tnmt.end_date}}</div>
              </router-link>
            </template>
          </div>
          <div class="ad_sticky ad">

            <!-- 라이브리포팅 우측 이벤트 정보 -->
            <report-info :event-info="eventInfo" />

            <display-container :section="312" align="right" empty-bg-color="transparent">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
              </template>
            </display-container>

            <!--<ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-5310971739125617"
             data-ad-slot="7285946505"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>-->

          </div>
        </div>

      </article>

    </div>

  </div>

</template>

<script>
  import Vue from 'vue'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  import CommonMethods from 'src/_mixins/CommonMethods'
	import CommonComputed from 'src/_mixins/CommonComputed'
  import { mapGetters } from 'vuex'
  export default {
    name: 'SubPageLayout',
    components: {
      DisplayContainer,
      ReportInfo
    },
    data () {
      return {
        hasAdElement: true
      }
    },
    props: {
      showTopBanner: {
        default: false,
        type: Boolean
      },
      noBorder: {
        default: false,
        type: Boolean
      },
      noRightPaddingTop: {
        default: false,
        type: Boolean
      },
      eventInfo: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    created () {
      this.getDisplayDataFromDB({access: this.getAccess, page: this.getCurrentComponentName})
      this.$store.dispatch('callUpcomingTournaments')
    },
    watch: {
      '$route'() {
        this.$nextTick(() => {
          this.checkAdContent()
        })
      }
    },
    updated () {
      this.checkAdContent()
    },
    mounted () {
      this.checkAdContent()
    },
		computed: {
      ...CommonComputed,
      ...mapGetters([
        'getDisplayDataFromDB',
        'getUpcomingTournaments'
      ]),
      getAccess () {
        return 'pc'
      }
    },
    methods: {
			...CommonMethods,
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
      checkAdContent () {
        if (this.$refs.adArea) {
          const targetElement = this.$refs.adArea.querySelector('a') || this.$refs.adArea.querySelector('img')
          this.hasAdElement = !!targetElement && targetElement.getAttribute('src') !== ''
        }
      }
    }
  }
</script>

<style scoped>
  .articles {
    position: relative;
    width: 100%;
    border-top: 1px solid #000;
  }
  .articles.no_border {
    border: 0;
  }
  .articles .left {
    width: 860px;
    display: table-cell;
  }
  .articles .right {
    width: 360px;
    display: table-cell;
    text-align: right;
    padding-top: 80px;
    padding-left: 60px;
  }
  .articles .right.no_padding_top {
    padding-top: 0;
  }
  .articles .right .ad_sticky {
    position: sticky;
    top: 100px;
  }
  .articles .right .ad /deep/ .display-container a {
    border-radius: 0 !important;
    padding-bottom: 50px;
  }
  .articles .right .ad /deep/ a img {
    width: 300px !important;
    height: 600px !important;
  }
  .articles .title {
    margin: 20px 0;
    width: 860px;
  }
  .articles h3 {
    font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    color: #000;
    display: inline-block;
    line-height: 1.3em;
  }
  .articles h3:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url('/statics/img/bi_title.png') no-repeat;
    background-size: contain;
    margin-right: 14px;
  }
  .articles h3 a span {
    font-family: 'SUIT Variable';
    font-size: 18px;
    line-height: 2.3em;
    margin-left: 5px;
  }
  .articles .dropdown {
    float: right;
    cursor: pointer;
    margin-top: 10px;
    position: relative;
    white-space: nowrap;
  }
  .articles .dropdown span {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    line-height: 1.0em;
    padding: 12px 18px;
    border-radius: 5.0em;
    border: 1px solid #aaa;
  }
  .articles .dropdown:hover span {
    background: #fff;
  }
  .articles .dropdown.on span {
    border: 1px solid #379339;
    background: #fff;
  }
  .articles .dropdown span:after {
    content: "";
    display: inline-block;
    width: 14px;
    height: 16px;
    background: url('/statics/img/a_arrow.png') no-repeat;
    background-size: contain;
    margin-left: 12px;
    margin-top: 2px;
    transform: rotate(90deg);
    transition: .15s;
  }
  .articles .dropdown.on span:after {
    transform: rotate(-90deg);
    margin-top: 0;
  }
  .articles .dropdown_lst {
    position: absolute;
    right: 0;
    transform: translate(0, 35px);
    display: inline-block;
    padding: 15px;
    border-radius: 1.0em;
    border: 1px solid #379339;
    box-shadow: 0 5px 5px rgba(0,0,0,0.25);
    background: #fff;
    z-index: 10;
  }
  .articles .dropdown_lst li {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4em;
    padding: 5px 10px;
    transition: .1s;
  }
  .articles .dropdown_lst li:hover {
    color: #379339;
    background: #fafafa;
  }
  .articles .lst > li {
    display: inline-block;
    width: 299px;
    min-height: 260px;
    padding: 0 20px 0 19px;
    margin-bottom: 32px;
    border-right: 1px solid #e5e5e5;
  }
  .articles .lst > li:nth-child(3n+1) {
    padding-left: 0;
    width: 280px;
  }
  .articles .lst > li:nth-child(3n+3) {
    padding-right: 0;
    width: 280px;
    border-right: none;
  }
  .articles .lst > li .img {
    position: relative;
    height: 170px;
  }
  .articles .lst > li .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 20px;
  }
  .articles .lst > li .subj {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    line-height: 1.45em;
    word-break: break-all;
    margin-top: 12px;
    max-height: 4.3em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    transition: .15s;
  }
  .articles .lst > li a:hover .subj {
    color: #379339;
  }
  .articles .lst_more {
    display: block;
    position: relative;
    text-align: center;
    cursor: pointer;
    height: 60px;
    line-height: 58px;
    margin-top: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    background: #000;
    transition: all .15s;
    border-radius: 8px;
  }
  .articles .lst_more:hover {
    color: #00ff64;
    background: #222;
  }
  .articles .lst_more:after {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    border: solid #00ff64;
    border-width: 0 2px 2px 0;
    position: absolute;
    right: 36px;
    top: 50%;
    transform: rotate(45deg) translate(0, -100%);
  }
  .articles .lst_no {
    display: none;
    position: relative;
    text-align: center;
    cursor: pointer;
    height: 60px;
    line-height: 58px;
    margin-top: 30px;
    font-size: 24px;
    color: #333;
    background: #fff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transition: all .15s;
  }
  .articles .lst_no:hover {
    background-color: #f5f5f5;
  }
	/* on wallpaper */
	.ad_wall {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000;
		z-index: -1;
	}
	/deep/ .ad_wall a {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div > img {
		position: fixed;
		width: 2500px !important;
		height: 1080px !important;
		left: 50%;
		transform: translate(-50%, 0);
	}
  .tnmt_sche {
    width: 100%;
		text-align: left;
    padding-left: 0;
    margin-bottom: 60px;
  }
  .tnmt_sche.no-ad {
    position: sticky;
    top: 100px;
  }
  .tnmt_sche .title {
    padding: 20px 0 24px;
    margin: 10px 0 0 0;
    width: 100%;
    border-top: 1px solid #000;
    position: relative;
  }
  .tnmt_sche .title .subj {
    font-family: 'Roboto Slab';
    font-size: 26px;
    font-weight: 900;
    color: #000;
    line-height: 1.25em;
    display: inline-block;
    letter-spacing: -0.02em;
  }
  .tnmt_sche .title .subj:before {
    content: "";
    display: inline-block;
    width: 29px;
    height: 32px;
    background: url(/statics/img/bi_title.png) no-repeat;
    background-size: contain;
    margin-right: 10px;
		float: left;
  }
  .tnmt_sche .title .subj i {
    float: left;
		width: 60%;
  }
  .tnmt_sche .title .more {
    position: absolute;
		right: 0;
		top: 50%;
		font-size: 12px;
    font-weight: 700;
		color: #000;
		padding: 6px 10px 8px;
		border: 1px solid #aaa;
		border-radius: 5.0em;
		line-height: 1.0em;
		transform: translate(0, -50%);
  }
  .tnmt_sche .ctnr {
		position: relative;
    display: inline-block;
		width: 100%;
		color: #000;
		background: #e5ede8;
		padding: 22px 20px;
		border-radius: 8px;
		margin-bottom: 8px;
  }
  .tnmt_sche .ctnr:hover {
		background: #dbe6df;
  }
  .tnmt_sche .ctnr:nth-child(odd) {
		/*background: #eaeaea;*/
  }
  .tnmt_sche .ctnr .brand {
    display: inline-block;
		width: 42px;
		height: 42px;
  }
  .tnmt_sche .ctnr .brand img {
    width: 100%;
    border-radius: 4px;
  }
  .tnmt_sche .ctnr .cont {
		display: inline-block;
    width: 155px;
		padding-left: 16px;
  }
  .tnmt_sche .ctnr .cont h5 {
		display: block;
		width: 100%;
    font-size: 15px;
		font-weight: 700;
    color: rgba(0,0,0,0.85);
		line-height: 1.2em;
		letter-spacing: -0.03em;
  }
  .tnmt_sche .ctnr .cont h6 {
    font-size: 13px;
		font-weight: 600;
		color: rgba(0,0,0,0.5);
    letter-spacing: -0.03em;
    line-height: 1.0em;
		margin-top: 8px;
  }
  .tnmt_sche .ctnr .cont p {
    font-size: 14px;
		font-weight: 400;
		color: #666;
		letter-spacing: -0.01em;
  }
  .tnmt_sche .ctnr .date {
    position: absolute;
		top: 20px;
		right: 20px;
		font-weight: 700;
		color: #008c03;
		text-align: right;
		letter-spacing: -0.05em;
		line-height: 1.5em;
  }
  .tnmt_sche .ctnr .date b {
		display: block;
    font-size: 17px;
		font-weight: 700;
  }
</style>
